import type { TripPlannerSurfaceActivityEntry } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityEntryTypes'
import { boundActivityDisplayText } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityDisplayText'
import type { ListingDrawerHotelDateSelection } from '../ListingDrawerSearchDates'
import { formatHotelSearchDisplayText } from './formatHotelSearchDisplayText'

export function buildHotelSearchSubmittedActivityEntry(
  searchQuery: string,
  dateSelection: ListingDrawerHotelDateSelection,
  occupancies: Array<App.Occupants>,
): TripPlannerSurfaceActivityEntry {
  return {
    kind: 'hotel_search_submitted',
    label: 'Searched hotels',
    displayText: boundActivityDisplayText(formatHotelSearchDisplayText(searchQuery, dateSelection, occupancies)),
    sourcePath: 'trip_planner.search.hotel',
    dataClassification: 'personalised_surface',
    occurredAt: new Date().toISOString(),
  }
}
